import React from "react";

import { ConfirmationModal } from "src/base-components/ConfirmationModal";

export type JsonSchemaUnsavedChangesModalProps = {
  open: boolean;
  onDiscard: () => void;
  onKeepEditing: () => void;
  canSave?: boolean;
  onSave?: () => void;
};

export const JsonSchemaUnsavedChangesModal: React.FC<
  JsonSchemaUnsavedChangesModalProps
> = ({ open, onDiscard, onKeepEditing, canSave, onSave }) => {
  const showSaveOption = canSave && onSave;

  const handleConfirm = () => {
    if (showSaveOption) {
      onSave();
    } else {
      onKeepEditing();
    }
  };

  const getDescription = () => {
    if (showSaveOption) {
      return "Changes made in the JSON view haven't been saved yet. Closing this panel will discard them.";
    }
    if (canSave === false) {
      return "The JSON schema is invalid and cannot be saved. You can continue editing or discard your changes.";
    }
    return "Changes made in the JSON view haven't been saved yet. Closing this panel will discard them.";
  };

  const description = getDescription();

  return (
    <ConfirmationModal
      cancelationButtonText="Discard"
      confirmationButtonText={showSaveOption ? "Save changes" : "Keep editing"}
      dataLoc="unsaved-schema-modal"
      description={description}
      open={open}
      title="Unsaved schema changes"
      hideCloseIcon
      onClose={onDiscard}
      onConfirm={handleConfirm}
    />
  );
};
